import React from 'react';
import { Typography } from 'antd';
import {
  SafetyOutlined,
  GlobalOutlined,
  FileProtectOutlined,
  ThunderboltOutlined,
  TeamOutlined,
  MedicineBoxOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const BENEFITS = [
  {
    icon: <SafetyOutlined style={{ fontSize: 26, color: '#6B35D4' }} />,
    title: '100% Secure',
    desc: 'Your health data is encrypted and stored on government-secured ABDM infrastructure.',
  },
  {
    icon: <GlobalOutlined style={{ fontSize: 26, color: '#6B35D4' }} />,
    title: 'Accessible Everywhere',
    desc: 'Access your health records from any hospital or clinic across India, anytime.',
  },
  {
    icon: <FileProtectOutlined style={{ fontSize: 26, color: '#6B35D4' }} />,
    title: 'Linked Records',
    desc: 'All your prescriptions, diagnoses and lab reports are linked to one ID.',
  },
  {
    icon: <ThunderboltOutlined style={{ fontSize: 26, color: '#E91E8C' }} />,
    title: 'Instant Creation',
    desc: 'Create your ABHA ID in under 3 minutes using just your Aadhaar number.',
  },
  {
    icon: <TeamOutlined style={{ fontSize: 26, color: '#6B35D4' }} />,
    title: 'Trusted by 55 Cr+',
    desc: 'Join India\'s largest digital health ecosystem trusted by millions of citizens.',
  },
  {
    icon: <MedicineBoxOutlined style={{ fontSize: 26, color: '#12B76A' }} />,
    title: 'Always Free',
    desc: 'Creating and using your ABHA ID is completely free for all Indian citizens.',
  },
];

const Benefits = () => {
  return (
    <section
      id="benefits"
      className="section-padding"
      style={{ background: 'linear-gradient(180deg, #fafbff 0%, #f5f0ff 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div
            className="inline-block px-4 py-1 rounded-full text-xs font-bold tracking-widest mb-4"
            style={{ background: '#e8f5e9', color: '#12B76A', letterSpacing: '0.1em' }}
          >
            WHY ABHA?
          </div>
          <Title level={2} style={{ color: '#1a1a2e' }}>
            Benefits of Your ABHA Health ID
          </Title>
          <Paragraph style={{ color: '#666', fontSize: 16, maxWidth: 480, margin: '0 auto' }}>
            Secure. Free. Yours. — Your personal digital health identity built for a healthier India.
          </Paragraph>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BENEFITS.map((b) => (
            <div
              key={b.title}
              className="hover-lift"
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: '28px 24px',
                border: '1px solid #f0eaff',
              }}
            >
              <div
                className="flex items-center justify-center rounded-2xl mb-5"
                style={{ width: 52, height: 52, background: '#f5f0ff' }}
              >
                {b.icon}
              </div>
              <h3 className="font-bold text-base mb-2" style={{ color: '#1a1a2e' }}>
                {b.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#666' }}>
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
